// extracted by mini-css-extract-plugin
module.exports = {"banner":"SSOjY","imageWrapper":"P0OuO","detail":"_92MLl","title":"_2Aihr","subtitle":"ZVPx9","button":"_3m4ul","image":"a4D8X"};